// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"c901c34b","453":"a20a8836","732":"75791941","977":"824340d7"}[chunkId] + ".chunk.js";
};